export default __webpack_public_path__ + "navigation-examples-location-snapping-1200-f0a43f3bff04b5e6a0dddcaa500482bf.png";